import {
  ADD_EDUCATION,
  ADD_EDUCATION_FAILURE,
  ADD_EDUCATION_SUCCESS,
  EDIT_EDUCATION,
  EDIT_EDUCATION_FAILURE,
  EDIT_EDUCATION_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
};
export default function EducationReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_EDUCATION:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_EDUCATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case ADD_EDUCATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    case EDIT_EDUCATION:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_EDUCATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case EDIT_EDUCATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    default:
      return {
        ...state,
      };
  }
}
